if( document.querySelectorAll('[js-action-quick-add]').length > 0 ){
  document.querySelectorAll('[js-action-quick-add]').forEach((elm)=>{
    elm.addEventListener('click', (target)=>{
      target.preventDefault();
      let quickaddHtml;
      if(target.target.closest('.SuggestionItemsList_Interior')){
        quickaddHtml = target.target.closest('.SuggestionItemsList_Interior').querySelector('.rainforest__quickadd_drawer').innerHTML;
      }else if(target.target.closest('.groups_quick__grid-item')){
        quickaddHtml = target.target.closest('.groups_quick__grid-item').querySelector('.rainforest__quickadd_drawer').innerHTML;
      }
      document.querySelector('[js-quick-add-layout-setup]').innerHTML = `<div class="rainforest__quickadd_drawer" data-snippet-type="rainforest-pdp-quick-add-drawer">${quickaddHtml}</div>`;
      document.querySelector('[js-quick-add-layout-setup]').querySelector('.rainforest__quickadd_drawer').classList.add('active'); 
      document.querySelector('.page-blury-overlay').classList.add('is-visible-mobile');
      document.body.classList.add('scrollOff-quickadd');        
    })
  })
} 

class PurchaseSelectionQuickadd extends HTMLElement{
  constructor(){
    super();
    this.querySelectorAll('.quickadd__selection_way input[type="radio"]').forEach((elm)=>{
      elm.addEventListener('change', ()=>{
        this.updateRadioOption();
      })
    })
    this.querySelectorAll('.quickadd__subscriptionOption input[type="radio"]').forEach((elm)=>{
      elm.addEventListener('change', ()=>{
        this.updateRadioOption();
      })
    })  
    this.querySelector('.quick__add__action-button .product-form__submit').addEventListener('click', (target)=>{
      target.preventDefault();
      this.updateRadioOption();this.quickaddAction();
    })
    this.querySelectorAll('[js-close-quick-add]').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        document.querySelector('.page-blury-overlay').classList.remove('is-visible-mobile');
        document.body.classList.remove('scrollOff-quickadd');      
        document.querySelector('[js-quick-add-layout-setup]').innerHTML = ``;
      })
    })        
  }
  updateRadioOption(){
    this.updateOptions();
    this.updateMasterId();
    this.updatequickadd();
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('.quickadd__selection_way input[type="radio"]:checked'), (input) => input.value);
  }   
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }   
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  // edited by Skio
  getProductData() {
    return this.productData ||= JSON.parse(this.querySelector('[data-product]').textContent);
  }  
  updatequickadd() {
    if(this.currentVariant){
      this.comparePrice = (this.currentVariant.compare_at_price > this.currentVariant.price) ? ((this.currentVariant.compare_at_price / 100).toFixed(2)) : ((this.currentVariant.price / 100).toFixed(2));

      this.normalPrice = (this.currentVariant.price / 100).toFixed(2);
      if( this.currentVariant.selling_plan_allocations[0] ){
        this.selling_plan_price = (this.currentVariant.selling_plan_allocations[0].price / 100).toFixed(2);
      }

      this.discountElSUB = this.querySelector(`.shouldUsed__fordiscountv [data-variant-name="${this.currentVariant.title}"]`).dataset.subDiscount;
      if(this.discountElSUB){
        this.finalPriceELSUB = this.comparePrice - this.discountElSUB;
        this.normalPriceSUB = this.finalPriceELSUB.toFixed(2);
        this.selling_plan_price = this.normalPriceSUB;
      }
 
      this.discountElOTP = this.querySelector(`.shouldUsed__fordiscountv [data-variant-name="${this.currentVariant.title}"]`).dataset.otpDisocunt;
      if(this.discountElOTP){
        this.finalPriceELOTP = this.comparePrice - this.discountElOTP;
        this.normalPriceOTP = this.finalPriceELOTP.toFixed(2);
        this.normalPrice = this.normalPriceOTP
      }    

      if( this.currentVariant.compare_at_price > this.currentVariant.price ){
        if( this.querySelector('.quickadd__onetimeSelection') ){
          this.querySelector('.quickadd__onetimeSelection').querySelector('.SubscriptionOptionPrice').innerHTML = `<span class="SubscriptionQuickPrice discounted_price_quickadd">$${this.normalPrice}</span><span class="SubscriptionQuickPrice"><s>$${this.comparePrice}</s></span>`
        }
        if( this.querySelector('.quickadd__SubscribeSelection') && this.currentVariant.selling_plan_allocations[0] ){
          this.querySelector('.quickadd__SubscribeSelection').querySelector('.SubscriptionOptionPrice').innerHTML = `<span class="SubscriptionQuickPrice discounted_price_quickadd">$${this.selling_plan_price}</span><span class="SubscriptionQuickPrice"><s>$${this.comparePrice}</s></span>`
        }
        if( this.currentVariant.available ){
          if( this.querySelector('.quickadd__subscriptionOption input[type="radio"]:checked').value == 'one-time'){
            this.querySelector('.quick__add__action-button').querySelector('.product-form__submit').innerHTML = `<span class="btn_txt_wp">Add to Cart —&nbsp; $${this.normalPrice} &nbsp;<s>$${this.comparePrice}</s></span>`;
          }else{
            this.querySelector('.quick__add__action-button').querySelector('.product-form__submit').innerHTML = `<span class="btn_txt_wp">Add to Cart —&nbsp; $${this.selling_plan_price} &nbsp;<s>$${this.comparePrice}</s></span>`;
          } 
          this.querySelector(`.product-form__submit[type="submit"]`).disabled = false;
        }else{
          if( this.querySelector('.quickadd__subscriptionOption input[type="radio"]:checked').value == 'one-time'){
            this.querySelector('.quick__add__action-button').querySelector('.product-form__submit').innerHTML = `<span class="btn_txt_wp">Sold Out —&nbsp; $${this.normalPrice} &nbsp;<s>$${this.comparePrice}</s></span>`;
          }else{
            this.querySelector('.quick__add__action-button').querySelector('.product-form__submit').innerHTML = `<span class="btn_txt_wp">Sold Out —&nbsp; $${this.selling_plan_price} &nbsp;<s>$${this.comparePrice}</s></span>`;
          } 
          this.querySelector(`.product-form__submit[type="submit"]`).disabled = true;
        }
      }else{
        if( this.querySelector('.quickadd__onetimeSelection') ){
          this.querySelector('.quickadd__onetimeSelection').querySelector('.SubscriptionOptionPrice').innerHTML = `<span class="SubscriptionQuickPrice"><span class="SubscriptionQuickPrice">$${this.normalPrice}</span></span>`
        }
        if( this.querySelector('.quickadd__SubscribeSelection') && this.currentVariant.selling_plan_allocations[0] ){
           this.querySelector('.quickadd__SubscribeSelection').querySelector('.SubscriptionOptionPrice').innerHTML = `<span class="SubscriptionQuickPrice discounted_price_quickadd">$${this.selling_plan_price}</span><span class="SubscriptionQuickPrice"><s>$${this.comparePrice}</s></span>`
        }
        if( this.currentVariant.available ){
          if( this.querySelector('.quickadd__subscriptionOption input[type="radio"]:checked').value == 'one-time' ){
            this.querySelector('.quick__add__action-button').querySelector('.product-form__submit').innerHTML = `<span class="btn_txt_wp">Add to Cart —&nbsp; $${this.normalPrice} &nbsp;</span>`;
          }else{
            this.querySelector('.quick__add__action-button').querySelector('.product-form__submit').innerHTML = `<span class="btn_txt_wp">Add to Cart —&nbsp; $${this.selling_plan_price} &nbsp;<s>$${this.comparePrice}</s></span>`;
          }
          this.querySelector(`.product-form__submit[type="submit"]`).disabled = false;
        }else{
          if( this.querySelector('.quickadd__subscriptionOption input[type="radio"]:checked').value == 'one-time' ){
            this.querySelector('.quick__add__action-button').querySelector('.product-form__submit').innerHTML = `<span class="btn_txt_wp">Sold Out —&nbsp; $${this.normalPrice} &nbsp;</span>`;
          }else{
            this.querySelector('.quick__add__action-button').querySelector('.product-form__submit').innerHTML = `<span class="btn_txt_wp">Sold Out —&nbsp; $${this.selling_plan_price} &nbsp;<s>$${this.comparePrice}</s></span>`;
          } 
          this.querySelector(`.product-form__submit[type="submit"]`).disabled = true;
        }
      }
      
      if( this.querySelector('.quickadd__subscriptionOption input[type="radio"]:checked').value == 'one-time' ){
        this.querySelectorAll('.quick__ad__Serving_name').forEach((elm)=>{
          if( elm.querySelector('.for__subscribe_serving') ){ elm.querySelector('.for__subscribe_serving').classList.add('hidden'); }
          if( elm.querySelector('.for__onetime_serving') ){ elm.querySelector('.for__onetime_serving').classList.remove('hidden'); }
        })
        this.querySelectorAll('.quickadd__details_servingDetails').forEach((elm)=>{
          if( elm.querySelector('.subTimedtl') ){ elm.querySelector('.subTimedtl').classList.add('hidden'); }
          if( elm.querySelector('.oneTimedtl') ){ elm.querySelector('.oneTimedtl').classList.remove('hidden'); }
        })
      }else{
        this.querySelectorAll('.quick__ad__Serving_name').forEach((elm)=>{
          if( elm.querySelector('.for__subscribe_serving') ){ elm.querySelector('.for__subscribe_serving').classList.remove('hidden'); }
          if( elm.querySelector('.for__onetime_serving') ){ elm.querySelector('.for__onetime_serving').classList.add('hidden'); }
        }) 
        this.querySelectorAll('.quickadd__details_servingDetails').forEach((elm)=>{
          if( elm.querySelector('.subTimedtl') ){ elm.querySelector('.subTimedtl').classList.remove('hidden'); }
          if( elm.querySelector('.oneTimedtl') ){ elm.querySelector('.oneTimedtl').classList.add('hidden'); }
        })        
      }

      if( this?.querySelector('.SubscriptionOptionDelivery')?.querySelector(`[data-supply-v="${this.currentVariant.title.trim()}"]`) ){
        this.querySelectorAll('.SubscriptionOptionDelivery mt').forEach((mt)=>{ mt.classList.add('hidden'); })
        this.querySelector('.SubscriptionOptionDelivery').querySelector(`[data-supply-v="${this.currentVariant.title.trim()}"]`).classList.remove('hidden');
      }
      
    }
  }

  getGuid() {
      let d = new Date().getTime();
      let d2 =  (performance && performance.now && (performance.now() * 1000)) || 0;
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
          let r = Math.random() * 16;
          if (d > 0) {
              r = (d + r) % 16 | 0;
              d = Math.floor(d / 16);
          } else {
              r = (d2 + r) % 16 | 0;
              d2 = Math.floor(d2 / 16);
          }
          return (c == 'x' ? r: (r & 0x7 | 0x8)).toString(16);
      }); 
  }  
  quickaddAction() {
    const submitButton = this.querySelector('.product-form__submit[name="add"]');
    const isOneTime = this.querySelector('.quickadd__subscriptionOption input[type="radio"]:checked').value === 'one-time';
    const processCustom = this.hasAttribute('data-cart-process') && this.getAttribute('data-cart-process') === 'true';
    
    submitButton.classList.add('loading');
    submitButton.disabled = true;
    
    this.cartDrawer = document.querySelector("cart-drawer");
    if (this.cartDrawer) this.cartDrawer.enableLoading();
    
    this.bundleCart = {
      'items': []
    };
    
    if (!window.quickAddIdMap) {
        window.quickAddIdMap = {};
        window.quickAddBoxIndexCounter = 0;
    }

    if (processCustom) {
      const bundleJsonElement = this.querySelector('.bundle-data-json');
      if (bundleJsonElement) {
        try {
          const bundleData = JSON.parse(bundleJsonElement.textContent);
          const currentId = this.currentVariant ? this.currentVariant.id : 'default';
          const data = bundleData[currentId] || bundleData["default"];
          
          if (data && data.ids) {
            let uniqID = new Date().getTime().toString(),
            bundleID = data.dynbox,
            customImage = data.custom_image,
            customProductTitle = data.product_title,
            customTitle = data.custom_title,
            customServing = data.custom_servings,
            customPrice = data.custom_price,
            customComparePrice = data.custom_compare_price,
            customSubPrice = data.custom_sub_price,
            customSubComparePrice = data.custom_sub_compare_price,                        
            customQuantity = data.custom_quantity,
            customQuantityGroup = data.qtys,
            customSellingPlan = data.custom_selling_plan,
            dynamicBoxIndex = 0;
            if (bundleID && bundleID.toString().trim() !== '') {
                const trimmedBundleID = bundleID.toString().trim();
                if (window.quickAddIdMap[trimmedBundleID] === undefined) {
                    window.quickAddIdMap[trimmedBundleID] = window.quickAddBoxIndexCounter;
                    window.quickAddBoxIndexCounter++;
                }
                dynamicBoxIndex = window.quickAddIdMap[trimmedBundleID];
            }

            const mainProperties = {
              _dynamicBoxId: bundleID,
              _dynamicBoxIndex: dynamicBoxIndex,
              _custom_product_title:customProductTitle,
              _custom_image:customImage,
              _custom_title:customTitle,
              _custom_serving:customServing,
              _custom_price:customPrice,
              _custom_compare_price:customComparePrice,
              _custom_sub_price:customSubPrice,
              _custom_sub_compare_price:customSubComparePrice,                            
              _custom_quantity:customQuantity,
              _custom_quantity_group:customQuantityGroup,
              _customSellingPlanName:customSellingPlan
            }; 
            
            const idArray = typeof data.ids === 'string' ? data.ids.split(',') : data.ids;
            const planArray = typeof data.plans === 'string' ? data.plans.split(',') : (data.plans || []);
            const qtyArray = typeof data.qtys === 'string' ? data.qtys.split(',') : (data.qtys || []);
            
            this.bundleCart.items = idArray.map((id, index) => {
                const itemBaseQty = parseInt(qtyArray[index]) || 1;
                const itemProperties = { 
                    ...mainProperties,
                    _base_qty: itemBaseQty.toString(),
                    _role: index === 0 ? 'main' : 'hidden',
                    _uniqBundleId: uniqID,
                    _selling_plan_id: parseInt(planArray[index])
                };
                const item = {
                    id: id.toString().trim(),
                    quantity: itemBaseQty,
                    properties: itemProperties
                };
                if (!isOneTime && planArray[index] && planArray[index].toString().trim() !== "") {
                    item.selling_plan = parseInt(planArray[index]);
                }
                return item;
            });
          }
        } catch (err) {
          console.error("Error parsing bundle JSON:", err);
        }
      }
    } else {
      let cartItem = {
        id: this.currentVariant.id,
        quantity: 1
      };

      if (!isOneTime) {
        const productData = this.getProductData();
        const filteredSellingPlanGroups = productData.selling_plan_groups.filter(group => 
          group.app_id === 'SKIO'
        );
        const validPlanIds = new Set();
        filteredSellingPlanGroups.forEach(group => {
          if (group.selling_plans) {
            group.selling_plans.forEach(plan => validPlanIds.add(plan.id));
          }
        });
        const validAllocation = this.currentVariant.selling_plan_allocations.find(allocation =>
          validPlanIds.has(allocation.selling_plan_id)
        );
        if (validAllocation) {
          cartItem.selling_plan = validAllocation.selling_plan_id;
        } else if (this.currentVariant.selling_plan_allocations.length > 0) {
          cartItem.selling_plan = this.currentVariant.selling_plan_allocations[0].selling_plan_id;
        }
      }
      this.bundleCart.items.push(cartItem);
    }

    if (this.cartDrawer) {
      this.bundleCart.sections = this.cartDrawer.getSectionsToRender().map((section) => section.section);
      this.bundleCart.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(this.bundleCart),
      credentials: 'same-origin'
    })
    .then((response) => response.json())
    .then((parsedState) => {
      if (this.cartDrawer && parsedState.sections) {
        this.cartDrawer.renderContent(parsedState.sections);
      }
    })
    .catch((e) => {
      console.error("Cart Add Error:", e);
    })
    .finally(() => {
      if (this.cartDrawer) {
        this.cartDrawer.disableLoading();
        this.cartDrawer.open();
      }
      submitButton.classList.remove('loading');
      submitButton.disabled = false;
      const overlay = document.querySelector('.page-blury-overlay');
      if (overlay) overlay.classList.remove('is-visible-mobile');
      document.body.classList.remove('scrollOff-quickadd');
      document.querySelectorAll('.rainforest__quickadd_drawer').forEach(elm => elm.classList.remove('active'));
      const items_grid_detect = document.querySelectorAll('.groups_quick__grid-item');
      if (items_grid_detect.length) { 
        items_grid_detect.forEach(el => el.classList.remove('active'));
      }
    });
  }

}
customElements.define('cus-quick-add',PurchaseSelectionQuickadd)